import React, { Component } from 'react';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { format } from 'date-fns';
import { MultiSelect } from 'primereact/multiselect';
import moment from 'moment';
import BotaoCheckList from './BotaoCheckList';
import ResumoCheckList from './ResumoCheckList';
import ItensEventuais from './ItensEventuais';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';
import 'assets/css/meus-pedidos.css';
import 'assets/css/pareceres-area-tecnica.css';

import { dominioDemandaCirurgica } from '../../config/database';

class PareceresAreaTecnica extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidosCirurgia: [],
      loading: false,
      abreModalResumo: false,
      pedidoSelecionado: null,
      codigoSelecionado: null,
      selectedDate: null,
      profissional: JSON.parse(localStorage.getItem('profissional')),
      configuracoes: JSON.parse(localStorage.getItem('configuracoes')),
      listaFiltroStatusParecer: ['Sem Parecer', 'Com Parecer', 'Todos'],
      filtroStatusParecerSelecionado: 'Sem Parecer',
      listaStatus: [],
      centrosCirurgicosFiltrados: JSON.parse(localStorage.getItem('profissional'))
        .centrosCirurgicos,
      botoesCentroCirurgico: [],
      listaConvenios: [],
      conveniosSelecionados: null,
      idsConveniosSelecionados: [],
      listaCampanhas: [],
      campanhasSelecionadas: null,
      idsCampanhasSelecionadas: [],
      campanhaRotina: { id: 0, nome: 'Rotina' },
      periodoFiltrado: null,
      disableRangeFilter: false,
      pt: {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
        monthNames: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        monthNamesShort: [
          'jan',
          'fev',
          'mar',
          'abr',
          'mai',
          'jun',
          'jul',
          'ago',
          'set',
          'out',
          'nov',
          'dez',
        ],
        today: 'Hoje',
        clear: 'Limpar',
        dateFormat: 'dd/mm/yy',
        weekHeader: 'Sm',
      },
    };
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentDidMount() {
    this.renderBotoesCentroCirurgico();
    this.setState({
      listaStatus: this.state.configuracoes.statusMostraPedidoAreaTecnica.map(
        status => status.descricao
      ),
    });
    this.listarConvenios();
    this.listarCampanhas();
  }

  listarConvenios = () => {
    dominioDemandaCirurgica.get('/api/convenio').then(response => {
      this.setState({ listaConvenios: response.data });
    });
  };

  listarCampanhas = () => {
    dominioDemandaCirurgica.get('/api/campanha').then(response => {
      this.setState({ listaCampanhas: [this.state.campanhaRotina, ...response.data] });
    });
  };

  renderBotoesCentroCirurgico = () => {
    if (this.state.profissional.centrosCirurgicos.length <= 1) {
      this.setState({
        botoesCentroCirurgico: [],
      });
      return;
    }

    const botoes = [];
    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (this.state.profissional.centrosCirurgicos.includes(centroCirurgico.id))
          botoes.push({
            id: centroCirurgico.id,
            departamento: centroCirurgico.departamento,
          });
      });

      this.setState({
        botoesCentroCirurgico: botoes,
      });
    });
  };

  listarPedidosCirurgia = (
    statusFiltrado,
    periodoFiltrado,
    centrosCirurgicosFiltrados,
    conveniosSelecionados,
    campanhasSelecionadas
  ) => {
    let periodoDataInicio = null;
    let periodoDataFim = null;

    if (periodoFiltrado && periodoFiltrado.length > 1 && periodoFiltrado[1] !== null) {
      periodoDataInicio = moment(periodoFiltrado[0]).format('YYYY-MM-DD');
      periodoDataFim = moment(periodoFiltrado[1]).add(1, 'days').format('YYYY-MM-DD');
    } else return;

    this.setState({ loading: true, disableRangeFilter: true });
    let api = '';

    const dados = {
      filtros: {
        centrosCirurgicos: centrosCirurgicosFiltrados.join(),
        periodoDataInicio,
        periodoDataFim,
        convenios: conveniosSelecionados?.length > 0 ? conveniosSelecionados.join() : undefined,
        campanhas: campanhasSelecionadas?.length > 0 ? campanhasSelecionadas.join() : undefined,
        filtrarPedidosSemCampanha: campanhasSelecionadas.includes(this.state.campanhaRotina.id)
          ? true
          : undefined,
      },
    };

    if (statusFiltrado === this.state.listaFiltroStatusParecer[0])
      api = `/api/pedidoCirurgiaAreaTecnicaSemParecer/${this.state.profissional.profissional_id}`;
    else if (statusFiltrado === this.state.listaFiltroStatusParecer[1])
      api = `/api/pedidoCirurgiaAreaTecnicaComParecer/${this.state.profissional.profissional_id}`;
    else if (statusFiltrado === this.state.listaFiltroStatusParecer[2])
      api = `/api/pedidoCirurgiaAreaTecnica/${this.state.profissional.profissional_id}`;

    dominioDemandaCirurgica.post(api, dados).then(
      res => {
        this.setState({
          pedidosCirurgia: res.data,
          loading: false,
          disableRangeFilter: false,
        });
      },
      () => {
        this.setState({ loading: false, disableRangeFilter: false });
      }
    );
  };

  codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        {rowData.pedidoSaudeSuplementar ? (
          <>
            <small
              className="sinalizacao-pedido-saude-suplementar"
              data-title={`Pedido de Saúde Suplementar\nConvênio: ${rowData.nomeConvenio}`}
            >
              CONVP
            </small>
            <br />
          </>
        ) : (
          <></>
        )}
        <a
          href="#"
          onClick={() => {
            this.setState({
              pedidoSelecionado: rowData.id,
              codigoSelecionado: rowData.codigo,
              abreModalResumo: true,
            });
          }}
        >
          <span>{rowData.codigo}</span>
        </a>
      </>
    );
  };

  renderBotoesFiltrosPeriodo = () => (
    <>
      <label
        htmlFor="filtroPeriodoDataCirurgia"
        style={{
          display: 'block',
          fontSize: '1vw',
          color: 'black',
        }}
      >
        Periodo da Data de Cirurgia
      </label>
      <Calendar
        id="filtroPeriodoDataCirurgiaParecer"
        locale={this.state.pt}
        value={this.state.periodoFiltrado}
        onChange={e => {
          this.listarPedidosCirurgia(
            this.state.filtroStatusParecerSelecionado,
            e.value,
            this.state.centrosCirurgicosFiltrados,
            this.state.idsConveniosSelecionados,
            this.state.idsCampanhasSelecionadas
          );

          this.setState({ periodoFiltrado: e.value });
        }}
        dateFormat="dd/mm/yy"
        selectionMode="range"
        disabled={this.state.disableRangeFilter}
        readOnlyInput
        showIcon
        style={{
          width: '20vw',
        }}
      />
    </>
  );

  handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let { centrosCirurgicosFiltrados } = this.state;
    if (centrosCirurgicosFiltrados.includes(centroCirurgico_id)) {
      if (centrosCirurgicosFiltrados.length === 1) return;
      centrosCirurgicosFiltrados = centrosCirurgicosFiltrados.filter(
        id => id !== centroCirurgico_id
      );
    } else {
      centrosCirurgicosFiltrados.push(centroCirurgico_id);
    }

    this.listarPedidosCirurgia(
      this.state.filtroStatusParecerSelecionado,
      this.state.periodoFiltrado,
      centrosCirurgicosFiltrados,
      this.state.idsConveniosSelecionados,
      this.state.idsCampanhasSelecionadas
    );

    this.setState({ centrosCirurgicosFiltrados });
  };

  areaTecnicaBodyTemplateMinhaArea = (rowData, area) => {
    const parecerAreaTecnica = rowData.pareceresPedido.find(
      parecer => parecer.areaTecnica.id === area.id
    );
    if (parecerAreaTecnica) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <span className="p-column-title">{area.header}</span>
          <BotaoCheckList
            pedido={rowData}
            area={area}
            parecer={parecerAreaTecnica}
            listarPedidosCirurgia={() =>
              this.listarPedidosCirurgia(
                this.state.filtroStatusParecerSelecionado,
                this.state.periodoFiltrado,
                this.state.centrosCirurgicosFiltrados,
                this.state.idsConveniosSelecionados,
                this.state.idsCampanhasSelecionadas
              )
            }
            configuracoes={this.state.configuracoes}
          />
        </div>
      );
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '30%' }}>
        <span className="p-column-title">{area.header}</span>
      </div>
    );
  };

  itensEventuaisBodyTemplate = rowData => {
    if (rowData.possuiItensEventuais)
      return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <span className="p-column-title">Itens Eventuais</span>
          <ItensEventuais pedido={rowData} />
        </div>
      );

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '30%' }}>
        <span className="p-column-title">Itens Eventuais</span>
      </div>
    );
  };

  pacienteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Paciente</span>
        <div>
          {rowData.GMR === 'True' && <small className="sinalizacao-gmr">GMR</small>}
          {rowData.eOncologica === '1' && <small className="sinalizacao-oncologica">ONCO</small>}
        </div>
        <span>{rowData.paciente}</span>
      </>
    );
  };

  procedimentoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Procedimento</span>
        <span>{rowData.procedimento}</span>
      </>
    );
  };

  equipeRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Equipe Requisitante</span>
        <span>{rowData.equipeRequisitante}</span>
      </>
    );
  };

  statusBodyTemplate = rowData => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <span className="bolinha-status" style={{ backgroundColor: rowData.corStatus }} />
        <span style={{ marginLeft: '20px' }}>{rowData.status}</span>
      </div>
    );
  };

  dataInclusaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Solicitada</span>
        <span>
          {new Date(rowData.dataInclusao).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </>
    );
  };

  profissionalRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Requisitante</span>
        <span>{rowData.profissionalRequisitante}</span>
      </>
    );
  };

  equipeBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Equipe</span>
        <span>{rowData.equipeRequisitante}</span>
      </>
    );
  };

  dataCirurgiaBodyTemplate = rowData => {
    const dataCirurgia = new Date(rowData.dataCirurgia);
    const dataCirurgiaFormatada = format(dataCirurgia, 'dd/MM/yyyy HH:mm');

    return (
      <>
        <span className="p-column-title">Data Hora Cirurgia</span>
        <span align="center" style={{ display: 'block' }}>
          {dataCirurgiaFormatada}
        </span>
      </>
    );
  };

  converterFonetico = string => {
    let novaString = string;

    // Remoção de acentuação
    novaString = novaString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Remoção de letras duplas
    let caracterAnterior = '';
    let stringAuxiliar = '';
    novaString.split('').forEach(caracter => {
      if (caracter !== caracterAnterior) {
        stringAuxiliar += caracter;
      }
      caracterAnterior = caracter;
    });

    novaString = stringAuxiliar;

    // Som de S
    novaString = novaString.replace(/Ç/g, 'S');
    novaString = novaString.replace(/Z/g, 'S');
    novaString = novaString.replace(/X/g, 'S');
    novaString = novaString.replace(/CE/g, 'SE');
    novaString = novaString.replace(/CI/g, 'SI');

    // Som de K
    novaString = novaString.replace(/CA/g, 'KA');
    novaString = novaString.replace(/CO/g, 'KO');
    novaString = novaString.replace(/CU/g, 'KU');
    novaString = novaString.replace(/QU/g, 'K');

    // Som de I
    novaString = novaString.replace(/Y/g, 'I');

    // Som de F
    novaString = novaString.replace(/PH/g, 'F');

    // Som de J
    novaString = novaString.replace(/GE/g, 'JE');
    novaString = novaString.replace(/GI/g, 'JI');

    // Som de G
    novaString = novaString.replace(/GU/g, 'G');

    // Som de M
    novaString = novaString.replace(/N/g, 'M');

    // Som de V
    novaString = novaString.replace(/W/g, 'U');

    return novaString;
  };

  customFilterFonetico = (value, filter) => {
    return this.converterFonetico(value.toUpperCase()).includes(
      this.converterFonetico(filter.toUpperCase())
    );
  };

  filterDate(valor, filtro) {
    const dataCirurgia = new Date(valor);
    const dataCirurgiaFormatada = format(dataCirurgia, 'dd/MM/yyyy');

    const filtroFormatado = format(filtro, 'dd/MM/yyyy');

    return dataCirurgiaFormatada === filtroFormatado;
  }

  onDateChange(e) {
    this.dt.filter(e.value, 'dataCirurgia', 'custom');
    this.setState({ selectedDate: e.value });
  }

  render() {
    if (!this.state.pedidosCirurgia) {
      return <div>carregando</div>;
    }

    const header = (
      <>
        <div className="table-header campo-filtro">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '78vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    const dateFilter = (
      <Calendar
        value={this.state.selectedDate}
        onChange={this.onDateChange}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data Cirurgia"
      />
    );

    const statusParecerFilter = (
      <div
        id="divfiltroparecer"
        style={{
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <br />
        <Autocomplete
          id="filtroParecer"
          options={this.state.listaFiltroStatusParecer}
          value={this.state.filtroStatusParecerSelecionado}
          style={{ width: '100%' }}
          onChange={(e, value) => {
            this.setState({ filtroStatusParecerSelecionado: value });
            this.listarPedidosCirurgia(
              value,
              this.state.periodoFiltrado,
              this.state.centrosCirurgicosFiltrados,
              this.state.idsConveniosSelecionados,
              this.state.idsCampanhasSelecionadas
            );
          }}
          disableClearable
          renderInput={params => <TextField {...params} variant="outlined" />}
        />
      </div>
    );

    const statusFilter = (
      <Autocomplete
        options={this.state.listaStatus}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ statusSelecionado: value });
          this.dt.filter(value, 'status', 'equals');
        }}
        value={this.state.statusSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Status" variant="outlined" />}
      />
    );

    return (
      <div id="laranja">
        <DialogPrime
          header={`Pedido nº ${this.state.codigoSelecionado}`}
          visible={this.state.abreModalResumo}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalResumo: false })}
        >
          <ResumoCheckList id={this.state.pedidoSelecionado} />
        </DialogPrime>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <div className="div-botoes-filtros">
              {}<span className="p-buttonset">{this.renderBotoesFiltrosPeriodo()}</span>
              <div className="div-botoes-filtros">
                <div className="div-botoes-filtro-centro-cirurgico">
                  <span className="p-buttonset">
                    {this.state.botoesCentroCirurgico.map(botao => (
                      <Button
                        label={botao.departamento}
                        key={botao.id}
                        onClick={() => this.handleClickBotaoCentroCirurgico(botao.id)}
                        className={
                          this.state.centrosCirurgicosFiltrados.some(
                            idCentroCirurgico => idCentroCirurgico === botao.id
                          )
                            ? ''
                            : 'botao-filtro-desabilitado'
                        }
                      />
                    ))}
                  </span>
                </div>
                <div className="div-selecao-convenios-filtro">
                  <MultiSelect
                    value={this.state.conveniosSelecionados}
                    options={this.state.listaConvenios}
                    optionLabel="descricao"
                    placeholder="Selecione um convênio"
                    maxSelectedLabels={4}
                    onChange={e => {
                      this.setState({ conveniosSelecionados: e.value }, () => {
                        const { conveniosSelecionados } = this.state;
                        if (conveniosSelecionados && conveniosSelecionados.length > 0) {
                          this.setState(
                            {
                              idsConveniosSelecionados: conveniosSelecionados.map(
                                convenio => convenio.id
                              ),
                            },
                            () =>
                              this.listarPedidosCirurgia(
                                this.state.filtroStatusParecerSelecionado,
                                this.state.periodoFiltrado,
                                this.state.centrosCirurgicosFiltrados,
                                this.state.idsConveniosSelecionados,
                                this.state.idsCampanhasSelecionadas
                              )
                          );
                        } else {
                          this.setState({ idsConveniosSelecionados: [] }, () =>
                            this.listarPedidosCirurgia(
                              this.state.filtroStatusParecerSelecionado,
                              this.state.periodoFiltrado,
                              this.state.centrosCirurgicosFiltrados,
                              this.state.idsConveniosSelecionados,
                              this.state.idsCampanhasSelecionadas
                            )
                          );
                        }
                      });
                    }}
                  />
                </div>
                <div className="div-selecao-campanha-filtro">
                  <MultiSelect
                    value={this.state.campanhasSelecionadas}
                    options={this.state.listaCampanhas}
                    optionLabel="nome"
                    placeholder="Selecione uma campanha"
                    maxSelectedLabels={this.state.listaCampanhas.length}
                    onChange={e => {
                      this.setState({ campanhasSelecionadas: e.value }, () => {
                        const { campanhasSelecionadas } = this.state;
                        if (campanhasSelecionadas && campanhasSelecionadas.length > 0) {
                          if (
                            campanhasSelecionadas[campanhasSelecionadas.length - 1].id !==
                            this.state.campanhaRotina.id
                          ) {
                            const campanhasSemRotina = campanhasSelecionadas.filter(
                              campanha => campanha.id !== this.state.campanhaRotina.id
                            );
                            this.setState(
                              {
                                campanhasSelecionadas: campanhasSemRotina,
                                idsCampanhasSelecionadas: campanhasSemRotina.map(
                                  campanha => campanha.id
                                ),
                              },
                              () =>
                                this.listarPedidosCirurgia(
                                  this.state.filtroStatusParecerSelecionado,
                                  this.state.periodoFiltrado,
                                  this.state.centrosCirurgicosFiltrados,
                                  this.state.idsConveniosSelecionados,
                                  this.state.idsCampanhasSelecionadas
                                )
                            );
                          } else
                            this.setState(
                              {
                                campanhasSelecionadas: [this.state.campanhaRotina],
                                idsCampanhasSelecionadas: [this.state.campanhaRotina.id],
                              },
                              () =>
                                this.listarPedidosCirurgia(
                                  this.state.filtroStatusParecerSelecionado,
                                  this.state.periodoFiltrado,
                                  this.state.centrosCirurgicosFiltrados,
                                  this.state.idsConveniosSelecionados,
                                  this.state.idsCampanhasSelecionadas
                                )
                            );
                        } else {
                          this.setState({ idsCampanhasSelecionadas: [] }, () =>
                            this.listarPedidosCirurgia(
                              this.state.filtroStatusParecerSelecionado,
                              this.state.periodoFiltrado,
                              this.state.centrosCirurgicosFiltrados,
                              this.state.idsConveniosSelecionados,
                              this.state.idsCampanhasSelecionadas
                            )
                          );
                        }
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <Card>
              <CardHeader color="rose" id="centroMeusPedidos" className="card-header">
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <p className="card-title">
                      <strong>Parecer Área Técnica</strong>
                    </p>
                  </Grid>
                </Grid>
              </CardHeader>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card">
                    <DataTable
                      ref={el => {
                        this.dt = el;
                      }}
                      value={this.state.pedidosCirurgia}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={100}
                      className="p-datatable-prime"
                      emptyMessage="Sem pedidos, filtre um intervalo de datas"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroMeusPedidos',
                          ''
                        )}#centroMeusPedidos`;
                      }}
                    >
                      <Column
                        field="codigo"
                        header="Nº pedido"
                        sortable
                        body={this.codigoBodyTemplate}
                        filter
                        filterPlaceholder="Nº pedido"
                        filterMatchMode="contains"
                        headerStyle={{ width: '14%' }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={this.statusBodyTemplate}
                        filter
                        filterElement={statusFilter}
                        headerStyle={{ width: '13%' }}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="paciente"
                        header="Paciente"
                        sortable
                        body={this.pacienteBodyTemplate}
                        filter
                        filterPlaceholder="Nome"
                        filterMatchMode="custom"
                        filterFunction={this.customFilterFonetico}
                        headerStyle={{ width: '22%' }}
                      />
                      <Column
                        field="profissionalRequisitante"
                        header="Requisitante"
                        sortable
                        body={this.profissionalRequisitanteBodyTemplate}
                        filter
                        filterPlaceholder="Requisitante"
                        filterMatchMode="custom"
                        headerStyle={{ width: '20%' }}
                        filterFunction={this.customFilterFonetico}
                      />
                      <Column
                        field="equipeRequisitante"
                        header="Equipe"
                        sortable
                        body={this.equipeBodyTemplate}
                        filter
                        filterPlaceholder="Equipe"
                        filterMatchMode="custom"
                        headerStyle={{ width: '20%' }}
                        filterFunction={this.customFilterFonetico}
                      />
                      <Column
                        field="dataCirurgia"
                        header="Data Cirurgia"
                        sortable
                        body={this.dataCirurgiaBodyTemplate}
                        filter
                        filterElement={dateFilter}
                        headerStyle={{ width: '13%' }}
                        filterFunction={this.filterDate}
                      />
                      <Column
                        key={this.state.profissional.areaTecnica_id}
                        field="areaTecnica"
                        header={this.state.profissional.areaTecnica_codigo}
                        id={this.state.profissional.areaTecnica_id}
                        body={this.areaTecnicaBodyTemplateMinhaArea}
                        filter
                        filterElement={statusParecerFilter}
                        headerStyle={{ width: '18%', textAlign: 'center' }}
                        style={{ textAlign: 'center' }}
                      />
                      {this.state.profissional?.areaTecnica_codigo === 'OPME' && (
                        <Column
                          field="possuiItensEventuais"
                          header="Itens Eventuais"
                          id="itensEventuais"
                          sortable
                          body={this.itensEventuaisBodyTemplate}
                          headerStyle={{ width: '18%', textAlign: 'center' }}
                          style={{ textAlign: 'center' }}
                        />
                      )}
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default PareceresAreaTecnica;
